import { createContext, useContext } from 'react';

export const ContentContext = createContext({
  left: 0,
  width: 0,
});

export const DisableBrowsingContext = createContext(false);

export const useIsBrowsingDisabled = () => {
  return useContext(DisableBrowsingContext);
};
